import React from 'react';
import {
  Camera, PenLine, ScanBarcode, Heart
} from 'lucide-react';
import { Button } from './ui/button';

export const DashboardFAB = React.memo(function DashboardFAB({
  showFab, setShowFab, todayLogCount, language,
  onScanClick, onWorkoutClick, onPhotoClick,
  onTextClick, onLabelClick, onFavoritesClick,
  fileInputRef, galleryInputRef, labelInputRef,
  handleFileSelect, handleLabelSelect
}) {
  return (
    <>
      {/* Desktop Action Buttons */}
      <div className="hidden md:flex gap-3 flex-wrap mt-6">
        <Button
          onClick={onPhotoClick}
          data-testid="add-meal-btn"
          className="btn-skewed bg-primary text-primary-foreground hover:bg-primary/90 font-heading uppercase tracking-wider text-lg px-8 py-4 h-auto"
        >
          <span className="flex items-center gap-2">
            <Camera className="w-5 h-5" />
            Photo
          </span>
        </Button>
        <Button
          onClick={onTextClick}
          data-testid="add-meal-text-btn"
          variant="outline"
          className="btn-skewed border-primary text-primary hover:bg-primary/10 font-heading uppercase tracking-wider text-lg px-8 py-4 h-auto"
        >
          <span className="flex items-center gap-2">
            <PenLine className="w-5 h-5" />
            {language === 'fr' ? 'Decrire' : 'Describe'}
          </span>
        </Button>
        <Button
          onClick={onLabelClick}
          data-testid="scan-label-btn"
          variant="outline"
          className="btn-skewed border-chart-carbs text-chart-carbs hover:bg-chart-carbs/10 font-heading uppercase tracking-wider text-lg px-8 py-4 h-auto"
        >
          <span className="flex items-center gap-2">
            <ScanBarcode className="w-5 h-5" />
            {language === 'fr' ? 'Etiquette' : 'Label'}
          </span>
        </Button>
        <Button
          onClick={onFavoritesClick}
          data-testid="favorites-btn"
          variant="outline"
          className="btn-skewed border-pink-500 text-pink-500 hover:bg-pink-500/10 font-heading uppercase tracking-wider text-lg px-8 py-4 h-auto"
        >
          <span className="flex items-center gap-2">
            <Heart className="w-5 h-5" />
            {language === 'fr' ? 'Favoris' : 'Favorites'}
          </span>
        </Button>
      </div>

      {/* Hidden File Inputs — must be IN the viewport with non-zero size on
          Android Samsung Chrome 148+, otherwise `.click()` is swallowed
          silently. iOS Safari similarly rejects `display: none`. Solution:
          1px×1px element fixed at the top-left corner, fully transparent.
          (Mai 2026 — Tetou Android 10 + Marc iPhone "scan photo ne marche
          pas" combined fix.) */}
      <input ref={fileInputRef} type="file" accept="image/*" capture="environment" onChange={handleFileSelect} style={{ position: 'fixed', top: 0, left: 0, width: 1, height: 1, opacity: 0, pointerEvents: 'none', zIndex: -1 }} data-testid="meal-file-input" />
      <input ref={galleryInputRef} type="file" accept="image/*" onChange={handleFileSelect} style={{ position: 'fixed', top: 0, left: 0, width: 1, height: 1, opacity: 0, pointerEvents: 'none', zIndex: -1 }} data-testid="meal-gallery-input" />
      <input ref={labelInputRef} type="file" accept="image/*" capture="environment" onChange={handleLabelSelect} style={{ position: 'fixed', top: 0, left: 0, width: 1, height: 1, opacity: 0, pointerEvents: 'none', zIndex: -1 }} data-testid="label-file-input" />
    </>
  );
});
